import TextAreaInput from 'components/forms/inputs/rhf-inputs/TextAreaInput.tsx';
import { ModalFooter } from 'components/modals/ModalFooter.tsx';
import { ModalHeader } from 'components/modals/ModalHeader.tsx';
import React from 'react';
import { useForm } from 'react-hook-form';
import { InvoiceBillingNotesDto } from 'types/invoices.ts';
import { t } from 'utils/getTranslations.ts';
import { logError } from 'utils/monitoring';

interface Props {
    billingNotes?: string;
    matterId?: number;
    partyId?: number;
    invoiceId: number;
    onClose: () => void;
    onSubmit: (value: InvoiceBillingNotesDto) => { unwrap: () => Promise<unknown> };
}

const InvoiceBillingNotesModal: React.FC<Props> = ({
    billingNotes,
    matterId,
    partyId,
    invoiceId,
    onClose,
    onSubmit,
}) => {
    const { handleSubmit, control } = useForm<InvoiceBillingNotesDto>({
        defaultValues: {
            matterId: matterId,
            partyId: partyId,
            billingNotes: billingNotes,
        },
    });

    const onSave = () => {
        handleSubmit(async (data) => {
            await onSubmit({ ...data, invoiceId })
                .unwrap()
                .then(() => {
                    onClose();
                })
                .catch((error) => {
                    console.error(error);
                    logError(error);
                });
        })();
    };

    return (
        <>
            <ModalHeader title={t('invoices.edit-billing-notes')} onCancel={onClose} />
            <div className="h-full overflow-y-auto px-6 py-3 max-sm:px-4 max-sm:py-6">
                <div className="flex flex-row gap-4">
                    <TextAreaInput
                        control={control}
                        label="matters.billing-notes"
                        placeholder="matters.billing-notes"
                        name="billingNotes"
                        minRows={10}
                        enableAutofill
                    />
                </div>
            </div>
            <ModalFooter onCancel={onClose} onSave={onSave} />
        </>
    );
};

export default InvoiceBillingNotesModal;
